import Styled from 'styled-components';

const HeaderContainer = Styled.div``;
const TagContainer = Styled.div`
display: flex;
flex-direction:row;
justify-content: space-between;`;

const DataWrapper = Styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 20px;
  
  > div {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-basis: 50%;
  }

  .anchor {
      align-self: baseline;
    }
`;

const RatingsContainer = Styled.div`
gap:40px
`;

const FilterTagWrapper = Styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 15px 0;
  
`;

const SelectsWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin: 15px 0;

  > div {
    + div {
      margin-left: 15px;
    }
  }
`;

const AuxiliaryTitleWrapper = Styled.div`
border-bottom: 1px solid #e8e8e8;
padding-bottom: 15px;
`;

export default HeaderContainer;
export {
  HeaderContainer,
  DataWrapper,
  SelectsWrapper,
  RatingsContainer,
  AuxiliaryTitleWrapper,
  FilterTagWrapper,
  TagContainer,
};
